import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import Login from './pages/login/index';
import Home from './pages/home/index';


export default (porps) => (
  <Switch>
    <Route exact={true} path="/" component={Login}></Route>
    <Route path="/visitHome" component={Home} />
    <Redirect to="/"/>
  </Switch>
)